import { displayRole, roleKey, roleOptionGroups } from "./partnerRoleCatalog";

export default function PartnerRoleOptions({ roles, includeCredits = false, preserveValue = "" }) {
  const groups = roleOptionGroups(roles);
  const known = new Set(roles.map((role) => roleKey(role.t)));
  const preserved = displayRole(preserveValue);
  const label = (role) => (includeCredits ? `${role.t} — ${role.c}C` : role.t);

  return (
    <>
      {roles.length === 0 && <option value="">No roles available</option>}
      {preserved && !known.has(roleKey(preserveValue)) && (
        <option value={preserved}>{preserved}</option>
      )}
      {groups.map((group) =>
        group.name ? (
          <optgroup key={group.name} label={group.name}>
            {group.roles.map((role) => (
              <option key={role.t} value={role.t}>
                {label(role)}
              </option>
            ))}
          </optgroup>
        ) : (
          group.roles.map((role) => (
            <option key={role.t} value={role.t}>
              {label(role)}
            </option>
          ))
        ),
      )}
    </>
  );
}
